import {setCurrentCategoryIndex, setProductFetching, reset} from '../actions/product';
import {setCurrentCategoryAndPosition} from '../actions/view';
import * as uri from '../config/uri';

import { fetchByCategory } from '../actions/api';
import { pushWithQueryParams } from '../services/uri';

const limit = 20;

const productReloadMiddleware = store => next => (action) => {
  if (action.type === 'RESET_CURRENT_CATEGORY') {
    const offset = 0;
    const { products, config, router } = store.getState();
    const { pathname } = router.location;

    store.dispatch(setProductFetching(true));
   
    const { categories } = config;
    const selectedCategory = products.activeCategoryIndex;
    if (pathname.indexOf('item') > -1) { // 1X view
      const categoryName = products.currentProduct.type.toLowerCase();
      store.dispatch(pushWithQueryParams(uri.rootPageUri + `category/${categoryName}`));
    } else if (pathname.indexOf('category') > 0 && selectedCategory > -1) {
      const categoryName = categories[selectedCategory].name;
      store.dispatch(setCurrentCategoryIndex(selectedCategory));
      store.dispatch(setCurrentCategoryAndPosition(categoryName, document.body.scrollTop));
      store.dispatch(fetchByCategory(categoryName, offset, limit));
    } else {
      store.dispatch(reset());
    }
  }

  next(action);

};

export default productReloadMiddleware;



// WEBPACK FOOTER //
// ./src/middleware/productReloadMiddleware.js